"use client";

import { c as _c } from "react/compiler-runtime";
import { Menu, X } from "lucide-react";
import { useMemo } from "react";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { useScrollLock } from "@/hooks/useScrollLock";
import { TenantSwitcher } from "@/components/layout/TenantSwitcher";
import { MegaMenu, MobileNavigation, MegaMenuShelf } from "@/components/layout/navigation";
import { NAVIGATION_CONFIG, getMenuIdForPath } from "@/lib/navigation";
import { useHeaderMenu } from "@/components/layout/hooks";
import { HeaderAuthDesktop, HeaderAuthMobile } from "@/components/layout/HeaderAuth";
interface HeaderProps {
  children?: React.ReactNode;
  className?: string;
}
export function Header(t0) {
  const $ = _c(38);
  const {
    children,
    className
  } = t0;
  const {
    mobileMenuOpen,
    toggleMobileMenu,
    closeMobileMenu,
    activeMenuId,
    handleOpenMenu,
    handleCloseMenu,
    handleTriggerMouseEnter,
    handleTriggerMouseLeave,
    handleShelfMouseEnter,
    handleShelfMouseLeave
  } = useHeaderMenu();
  useScrollLock(mobileMenuOpen);
  const pathname = usePathname() ?? "";
  const isAdmin = pathname === "/admin" || pathname.startsWith("/admin/");
  let t1;
  if ($[0] !== pathname) {
    t1 = getMenuIdForPath(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentSectionId = t1;
  const t2 = isAdmin ? "relative w-full z-50" : "sticky top-0 w-full z-50";
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = cn(t2, className);
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TenantSwitcher className="shrink-0" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeMenuId || $[7] !== currentSectionId || $[8] !== handleCloseMenu || $[9] !== handleOpenMenu || $[10] !== handleTriggerMouseEnter || $[11] !== handleTriggerMouseLeave) {
    t5 = NAVIGATION_CONFIG.map(config => <MegaMenu key={config.id} config={config} isActive={activeMenuId === config.id} isCurrentSection={currentSectionId === config.id && (!activeMenuId || activeMenuId === config.id)} onOpen={handleOpenMenu} onClose={handleCloseMenu} onMouseEnter={handleTriggerMouseEnter} onMouseLeave={handleTriggerMouseLeave} />);
    $[6] = activeMenuId;
    $[7] = currentSectionId;
    $[8] = handleCloseMenu;
    $[9] = handleOpenMenu;
    $[10] = handleTriggerMouseEnter;
    $[11] = handleTriggerMouseLeave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <nav className="hidden xl:flex self-stretch gap-1 flex-1">{t5}</nav>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== children) {
    t7 = children && <div className="hidden xl:flex px-4">{children}</div>;
    $[15] = children;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <nav className="hidden sm:flex items-center gap-2 ml-auto"><HeaderAuthDesktop /></nav>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== mobileMenuOpen || $[19] !== toggleMobileMenu) {
    t9 = !mobileMenuOpen && <button onClick={toggleMobileMenu} className="xl:hidden ml-auto sm:ml-0 -mr-0.5 w-11 h-11 flex items-center justify-center rounded-xl bg-primary/[0.06] text-primary hover:bg-primary/10 transition-colors" aria-label={"Men\xFC \xF6ffnen"}><Menu className="w-5 h-5" /></button>;
    $[18] = mobileMenuOpen;
    $[19] = toggleMobileMenu;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t7 || $[23] !== t9) {
    t10 = <div className="relative flex items-center gap-10 h-[var(--header-height)] px-[clamp(16px,5vw,80px)] bg-surface border-b border-primary/[0.08]">{t4}{t6}{t7}{t8}{t9}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== closeMobileMenu || $[26] !== mobileMenuOpen) {
    t11 = mobileMenuOpen && <div className="xl:hidden fixed inset-0 z-50 bg-primary-hover text-surface flex flex-col overflow-y-auto"><div className="flex justify-between items-center px-6 py-5"><span className="text-xl font-extrabold tracking-[-0.02em]">Ökopunktemarkt</span><button onClick={closeMobileMenu} className="w-11 h-11 flex items-center justify-center rounded-xl bg-surface/10" aria-label={"Men\xFC schlie\xDFen"}><X className="w-5 h-5 text-surface" /></button></div><div className="flex-1 flex flex-col px-6"><MobileNavigation onItemClick={closeMobileMenu} /></div><div className="p-6"><HeaderAuthMobile onClose={closeMobileMenu} /></div></div>;
    $[25] = closeMobileMenu;
    $[26] = mobileMenuOpen;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== activeMenuId || $[29] !== handleCloseMenu || $[30] !== handleShelfMouseEnter || $[31] !== handleShelfMouseLeave) {
    t12 = <MegaMenuShelf configs={NAVIGATION_CONFIG} activeId={activeMenuId} onClose={handleCloseMenu} onMouseEnter={handleShelfMouseEnter} onMouseLeave={handleShelfMouseLeave} />;
    $[28] = activeMenuId;
    $[29] = handleCloseMenu;
    $[30] = handleShelfMouseEnter;
    $[31] = handleShelfMouseLeave;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t3) {
    t13 = <><header className={t3}>{t10}{t11}{t12}</header></>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t3;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
}